import React from 'react';
import {useNavigate} from 'react-router-dom';
import {PrimaryButton, SecondaryButton} from './index';

const ViewLink = ({permitted, route}) => {
  const navigate = useNavigate();

  return (
    <SecondaryButton
      buttonText="View History"
      onClick={() => {
        if (permitted) {
          navigate(route);
        }
      }}
      className="w-full lg:w-fit !h-10"
      disabled={!permitted}
    />
  );
};

const PerformBtn = ({setOpen, permitted, btnText}) => (
  <PrimaryButton
    buttonText={btnText}
    onClick={() => {
      setOpen(true);
    }}
    className="w-full lg:w-fit !h-10"
    disabled={!permitted}
  />
);

export {ViewLink, PerformBtn};
